import React, { useEffect, useRef, useState } from 'react'
import { Card, Icon, Modal, Spin } from 'antd'
import { Player } from 'video-react'
import 'video-react/dist/video-react.css'

import { Asset } from 'src/types'

import { Breadcrumb, PageHeader, Text } from 'src/components/Ant'
import AssetsService from 'src/services/api/assets'
import images from 'src/config/images'

import { WrapContent } from './styles'

export default function Videos(): JSX.Element {
  const [selectedItem, setSelectedItem] = useState<Asset>()
  const [showModal, setShowModal] = useState(false)
  const [list, setList] = useState<Asset[]>([])
  const [loading, setLoading] = useState(false)

  const refVideo = useRef<typeof Player>()

  useEffect(() => {
    ;(async () => {
      setLoading(true)

      const response = await AssetsService.getAll()

      setLoading(false)

      if (response.data) {
        setList(response.data)
      }
    })()
  }, [])

  return (
    <>
      <div style={{ backgroundColor: '#fff', padding: '12px 0 0 12px' }}>
        <Breadcrumb items={['web.side.help.title', 'web.side.help.video']} />
      </div>
      <PageHeader title="web.side.help.video" />
      <WrapContent>
        {loading && (
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flex: 1,
              justifyContent: 'center'
            }}
          >
            <Spin />
          </div>
        )}
        <div>
          {list.map(item => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              onClick={() => {
                setShowModal(true)
                setSelectedItem(item)
              }}
              key={item.assets_tenant_id}
            >
              <Card
                style={{
                  float: 'left',
                  width: 300,
                  marginBottom: 16,
                  marginRight: 16
                }}
                cover={
                  <div
                    style={{
                      alignItems: 'center',
                      borderBottom: '1px solid #e8e8e8',
                      display: 'flex',
                      flex: 1,
                      justifyContent: 'center'
                    }}
                  >
                    <img src={images.logoIcon} height={150} alt="" />
                  </div>
                }
              >
                <div
                  style={{
                    alignItems: 'flex-start',
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    minHeight: 42
                  }}
                >
                  <Icon
                    type="play-circle"
                    key="play"
                    style={{ fontSize: 24, marginRight: 16 }}
                  />
                  <Text strong>{item.description}</Text>
                </div>
              </Card>
            </a>
          ))}
        </div>
      </WrapContent>
      <Modal
        footer={[]}
        forceRender
        title={selectedItem && selectedItem.description}
        visible={showModal}
        onCancel={() => {
          setShowModal(false)
          refVideo.current.pause()
        }}
        width={800}
      >
        {!!selectedItem && (
          <Player
            ref={refVideo}
            playsInline
            poster="/media/logo_a.png"
            src={selectedItem.value}
          />
        )}
      </Modal>
    </>
  )
}
